import React from 'react';
export function SymptomGrid() {
  const noticedSymptoms = [{
    label: 'Weight gain',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12" data-id="element-307">
          <path d="M12 3v18" data-id="element-308" />
          <path d="M4 9h16" data-id="element-309" />
          <path d="M4 9l2 8h12l2-8" data-id="element-310" />
          <path d="M9 21h6" data-id="element-311" />
        </svg>
  }, {
    label: 'Low libido',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12" data-id="element-312">
          <path d="M19.5 7.5c0-2.5-2-4.5-4.5-4.5-1.5 0-2.8.8-3.5 2-.7-1.2-2-2-3.5-2-2.5 0-4.5 2-4.5 4.5 0 3.5 4.5 7 8 9" data-id="element-313" />
          <path d="M12 13v8" data-id="element-314" />
          <path d="M9 18l3 3 3-3" data-id="element-315" />
        </svg>
  }, {
    label: 'Low energy',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12" data-id="element-316">
          <rect x="2" y="7" width="16" height="10" rx="2" data-id="element-317" />
          <path d="M22 11v2" data-id="element-318" />
          <path d="M6 10v4" data-id="element-319" />
        </svg>
  }, {
    label: 'Sleep disruption',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12" data-id="element-320">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" data-id="element-321" />
          <path d="M9 8h4l-4 5h4" data-id="element-322" />
        </svg>
  }, {
    label: 'Hot flashes',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12" data-id="element-323">
          <path d="M12 2c0 0-5 4.5-5 10a5 5 0 0 0 10 0c0-5.5-5-10-5-10z" data-id="element-324" />
          <path d="M12 10c-1.5 1.5-1.5 3.5 0 5" data-id="element-325" />
        </svg>
  }, {
    label: 'Anxiety',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12" data-id="element-326">
          <circle cx="12" cy="12" r="10" data-id="element-327" />
          <path d="M8 12l2-3 4 6 2-3" data-id="element-328" />
        </svg>
  }, {
    label: 'Night sweats',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12" data-id="element-329">
          <path d="M12 22a5 5 0 0 0 5-5c0-4-5-9-5-9s-5 5-5 9a5 5 0 0 0 5 5z" data-id="element-330" />
          <path d="M12 14v4" data-id="element-331" />
        </svg>
  }, {
    label: 'Mood swings',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12" data-id="element-332">
          <path d="M4 12c2-4 6-4 8 0s6 4 8 0" data-id="element-333" />
        </svg>
  }];
  const unrecognizedSymptoms = [{
    label: 'Brain fog',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12" data-id="element-334">
          <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" data-id="element-335" />
        </svg>
  }, {
    label: 'Skin changes',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12" data-id="element-336">
          <path d="M12 2L7 7c-3 3-3 8 0 11s8 3 11 0 3-8 0-11L12 2z" data-id="element-337" />
          <path d="M12 2v20" data-id="element-338" />
        </svg>
  }, {
    label: 'Joint pain',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12" data-id="element-339">
          <path d="M4 12h6l4 6h6" data-id="element-340" />
          <circle cx="10" cy="12" r="2" data-id="element-341" />
        </svg>
  }, {
    label: 'Tingling',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12" data-id="element-342">
          <circle cx="12" cy="4" r="1" data-id="element-343" />
          <circle cx="12" cy="20" r="1" data-id="element-344" />
          <circle cx="20" cy="12" r="1" data-id="element-345" />
          <circle cx="4" cy="12" r="1" data-id="element-346" />
          <circle cx="17.5" cy="6.5" r="1" data-id="element-347" />
          <circle cx="6.5" cy="17.5" r="1" data-id="element-348" />
          <circle cx="17.5" cy="17.5" r="1" data-id="element-349" />
          <circle cx="6.5" cy="6.5" r="1" data-id="element-350" />
        </svg>
  }, {
    label: 'Body odor',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12" data-id="element-351">
          <path d="M8 22v-5c0-2 2-2 2-4s-2-2-2-4 2-2 2-4V2" data-id="element-352" />
          <path d="M16 22v-5c0-2-2-2-2-4s2-2 2-4-2-2-2-4V2" data-id="element-353" />
        </svg>
  }];
  return <section className="bg-orla-bone py-16 md:py-32" data-id="element-354">
      <div className="max-w-[1240px] mx-auto px-6" data-id="element-355">
        {/* Part 1: Symptoms you notice */}
        <div data-id="element-356">
          <h2 className="font-display italic text-[32px] md:text-[48px] text-orla-ink text-center mb-12" data-id="element-357">
            Address the symptoms you notice…
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-358">
            {noticedSymptoms.map((symptom, idx) => <div key={idx} className="bg-white rounded-2xl py-8 px-6 flex flex-col items-center justify-center shadow-[0_2px_12px_rgba(31,27,23,0.06)] cursor-pointer transition-all duration-200 ease-out hover:-translate-y-1 hover:shadow-[0_8px_24px_rgba(31,27,23,0.1)]" data-id="element-359">
                <div className="text-orla-sienna" data-id="element-360">{symptom.icon}</div>
                <span className="mt-3 font-body font-medium text-[15px] text-orla-ink text-center" data-id="element-361">
                  {symptom.label}
                </span>
              </div>)}
          </div>
        </div>

        {/* Part 2: Symptoms you don't recognize */}
        <div className="mt-24" data-id="element-362">
          <h3 className="font-display italic text-[24px] md:text-[32px] text-orla-ink text-center mb-12" data-id="element-363">
            …and those you might not recognize.
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-6" data-id="element-364">
            {unrecognizedSymptoms.map((symptom, idx) => <div key={idx} className={`bg-white rounded-2xl py-8 px-6 flex flex-col items-center justify-center shadow-[0_2px_12px_rgba(31,27,23,0.06)] cursor-pointer transition-all duration-200 ease-out hover:-translate-y-1 hover:shadow-[0_8px_24px_rgba(31,27,23,0.1)] ${idx === unrecognizedSymptoms.length - 1 ? 'col-span-2 md:col-span-1' : ''}`} data-id="element-365">
                <div className="text-orla-sienna" data-id="element-366">{symptom.icon}</div>
                <span className="mt-3 font-body font-medium text-[15px] text-orla-ink text-center" data-id="element-367">
                  {symptom.label}
                </span>
              </div>)}
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 text-center" data-id="element-368">
          <p className="font-display italic text-[15px] text-orla-muted" data-id="element-369">
            Tap a symptom to learn more.
          </p>
          <a href="#" className="mt-2 inline-block font-body font-semibold text-[15px] text-orla-saffron hover:underline" data-id="element-370">
            View all 100+ symptoms &rarr;
          </a>
        </div>
      </div>
    </section>;
}